const disputeForm = {
	schema : {
		type       : 'object',
		required   : ['reason', 'notes'],
		properties : {
			reason : { type : 'number', data : [], minLength : 1 },
			notes  : { type : 'string', minLength : 1 },
		},
	},
	uiSchema : {
		reason : {
			'ui:widget'  : 'dropDown',
			'ui:options' : {
				label               : 'Reason',
				placeholder         : 'Select',
				wrapperClassName    : 'margin-bottom-10 margin-top-15 col-md-12 col-xs-12',
				inputGroupClassName : 'col-xs-12',
				inputClassName      : 'input-border-curve',
				selectClassName     : 'report-filter-select',
				labelFont           : 'font-light',
				large               : false,
			},
		},
		notes : {
			'ui:widget'  : 'textInput',
			'ui:options' : {
				label               : 'Add Note',
				componentClass      : 'textarea',
				placeholder         : '(Please explain why you are disputing this invoice)',
				labelSubText        : '* we will notify the officers/coordinators',
				textAreaRows        : 6,
				wrapperClassName    : 'margin-bottom-15 col-md-12 col-xs-12 report-filter-select',
				inputGroupClassName : 'col-xs-12',
				inputClassName      : 'input-border-curve',
				labelFont           : 'font-light',
			},
		},
	},
};

export default disputeForm;
